import ScrollToTop from "./app/elements/scroll-to-top";
import {useEffect} from "react";
import RootLayout from './layouts/root-layout';
import axios from "./api/axios";

function App() {
    useEffect(() => {

        (async () => {
            await axios.post(`/tracking/set-site-visit`);
        })();

    }, []);

    return (
        <div className="App">
            <>
                <ScrollToTop/>
                <RootLayout/>
            </>
        </div>
    );
}

export default App;
